module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Participants"},"fr":{"title":"Participants"}}')
  delete Component.options._Ctor
}
